import * as React from 'react';
import Styled from 'styled-components';

import { Button, IButtonProps } from '../../../Button';
import { media } from '../../../../lib/StyledComponents';

export type CTAButtonProps = IButtonProps & { inline?: undefined };

const QaButton = Styled(Button)<IButtonProps>`
  margin-bottom: 0.75em;

  ${media.small`
    margin-right: 1.5em;
    margin-bottom: 0;
    padding-left: 4em;
    padding-right: 4em;
  `}
`;

const CTAButton: React.FunctionComponent<CTAButtonProps> = props => <QaButton {...props} inline={true} />;
CTAButton.displayName = 'KBACTAButton';

export default CTAButton;
